var _g, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 160,
    viewBox: "0 0 187 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.31232 143C8.40127 143 8.46354 143.033 8.49913 143.1L15.6246 158.774C15.6424 158.791 15.6513 158.808 15.6513 158.824C15.6513 158.941 15.589 159 15.4645 159C15.3933 159 15.34 158.967 15.3044 158.9L8.31232 143.602L1.34693 158.9C1.31135 158.967 1.25798 159 1.18681 159C1.06227 159 1 158.941 1 158.824C1 158.808 1.0089 158.791 1.02669 158.774L8.15219 143.1C8.18778 143.033 8.24115 143 8.31232 143Z",
    fill: "#272A32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3552 143C30.4619 143 30.5153 143.059 30.5153 143.176V158.674H42.2577C42.3822 158.674 42.4445 158.724 42.4445 158.824C42.4445 158.941 42.3822 159 42.2577 159H30.3552C30.2306 159 30.1684 158.941 30.1684 158.824V143.176C30.1684 143.059 30.2306 143 30.3552 143Z",
    fill: "#272A32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6897 143C65.1272 143 67.1554 143.761 68.7744 145.282C68.81 145.316 68.8278 145.357 68.8278 145.408C68.8278 145.525 68.7655 145.583 68.641 145.583C68.5876 145.583 68.5432 145.566 68.5076 145.533C66.9597 144.062 65.0204 143.326 62.6897 143.326C60.3591 143.326 58.4109 144.062 56.8452 145.533C55.2974 146.987 54.5234 148.81 54.5234 151C54.5234 153.19 55.2974 155.021 56.8452 156.492C58.4109 157.947 60.3591 158.674 62.6897 158.674C64.9848 158.674 66.9063 157.955 68.4542 156.517V151.176H60.3146C60.19 151.176 60.1278 151.117 60.1278 151C60.1278 150.883 60.19 150.824 60.3146 150.824H68.641C68.7655 150.824 68.8278 150.883 68.8278 151V156.592C68.8278 156.643 68.81 156.684 68.7744 156.718C67.1554 158.239 65.1272 159 62.6897 159C60.2701 159 58.2419 158.239 56.605 156.718C54.986 155.18 54.1765 153.274 54.1765 151C54.1765 148.726 54.986 146.829 56.605 145.307C58.2419 143.769 60.2701 143 62.6897 143Z",
    fill: "#272A32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6446 143C94.0643 143 96.1192 143.786 97.8094 145.357C99.5174 146.912 100.371 148.793 100.371 151C100.371 153.207 99.5174 155.096 97.8094 156.668C96.1192 158.223 94.0643 159 91.6446 159C90.0612 159 88.6289 158.641 87.348 157.922C86.0848 157.203 85.0973 156.233 84.3857 155.013C83.6918 153.792 83.3449 152.455 83.3449 151C83.3449 149.545 83.6918 148.208 84.3857 146.987C85.0973 145.767 86.0848 144.797 87.348 144.078C88.6289 143.359 90.0612 143 91.6446 143ZM91.6446 143.326C89.3495 143.326 87.4458 144.07 85.9335 145.558C84.439 147.029 83.6918 148.843 83.6918 151C83.6918 153.157 84.439 154.979 85.9335 156.467C87.4458 157.938 89.3495 158.674 91.6446 158.674C93.9753 158.674 95.9502 157.93 97.5692 156.442C99.206 154.937 100.024 153.123 100.024 151C100.024 148.877 99.206 147.071 97.5692 145.583C95.9502 144.078 93.9753 143.326 91.6446 143.326Z",
    fill: "#272A32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.072 143H117.447C120.863 143 123.389 143.761 125.026 145.282C126.449 146.62 127.161 148.526 127.161 151C127.161 153.474 126.449 155.38 125.026 156.718C123.389 158.239 120.863 159 117.447 159H115.072C114.947 159 114.885 158.941 114.885 158.824C114.885 158.724 114.947 158.674 115.072 158.674H117.447C120.774 158.674 123.211 157.938 124.759 156.467C126.111 155.196 126.787 153.374 126.787 151C126.787 148.626 126.111 146.804 124.759 145.533C123.211 144.062 120.774 143.326 117.447 143.326H115.072C114.947 143.326 114.885 143.276 114.885 143.176C114.885 143.059 114.947 143 115.072 143Z",
    fill: "#272A32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.056 143C148.145 143 148.207 143.033 148.242 143.1L155.368 158.774C155.386 158.791 155.395 158.808 155.395 158.824C155.395 158.941 155.332 159 155.208 159C155.137 159 155.083 158.967 155.048 158.9L148.056 143.602L141.09 158.9C141.055 158.967 141.001 159 140.93 159C140.806 159 140.743 158.941 140.743 158.824C140.743 158.808 140.752 158.791 140.77 158.774L147.896 143.1C147.931 143.033 147.985 143 148.056 143Z",
    fill: "#272A32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.273 143C179.693 143 181.748 143.786 183.438 145.357C185.146 146.912 186 148.793 186 151C186 153.207 185.146 155.096 183.438 156.668C181.748 158.223 179.693 159 177.273 159C175.69 159 174.258 158.641 172.977 157.922C171.713 157.203 170.726 156.233 170.014 155.013C169.32 153.792 168.974 152.455 168.974 151C168.974 149.545 169.32 148.208 170.014 146.987C170.726 145.767 171.713 144.797 172.977 144.078C174.258 143.359 175.69 143 177.273 143ZM177.273 143.326C174.978 143.326 173.074 144.07 171.562 145.558C170.068 147.029 169.32 148.843 169.32 151C169.32 153.157 170.068 154.979 171.562 156.467C173.074 157.938 174.978 158.674 177.273 158.674C179.604 158.674 181.579 157.93 183.198 156.442C184.835 154.937 185.653 153.123 185.653 151C185.653 148.877 184.835 147.071 183.198 145.583C181.579 144.078 179.604 143.326 177.273 143.326Z",
    fill: "#272A32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31232 143C8.40127 143 8.46354 143.033 8.49913 143.1L15.6246 158.774C15.6424 158.791 15.6513 158.808 15.6513 158.824C15.6513 158.941 15.589 159 15.4645 159C15.3933 159 15.34 158.967 15.3044 158.9L8.31232 143.602L1.34693 158.9C1.31135 158.967 1.25798 159 1.18681 159C1.06227 159 1 158.941 1 158.824C1 158.808 1.0089 158.791 1.02669 158.774L8.15219 143.1C8.18778 143.033 8.24115 143 8.31232 143Z",
    stroke: "#272A32",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3552 143C30.4619 143 30.5153 143.059 30.5153 143.176V158.674H42.2577C42.3822 158.674 42.4445 158.724 42.4445 158.824C42.4445 158.941 42.3822 159 42.2577 159H30.3552C30.2306 159 30.1684 158.941 30.1684 158.824V143.176C30.1684 143.059 30.2306 143 30.3552 143Z",
    stroke: "#272A32",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6897 143C65.1272 143 67.1554 143.761 68.7744 145.282C68.81 145.316 68.8278 145.357 68.8278 145.408C68.8278 145.525 68.7655 145.583 68.641 145.583C68.5876 145.583 68.5432 145.566 68.5076 145.533C66.9597 144.062 65.0204 143.326 62.6897 143.326C60.3591 143.326 58.4109 144.062 56.8452 145.533C55.2974 146.987 54.5234 148.81 54.5234 151C54.5234 153.19 55.2974 155.021 56.8452 156.492C58.4109 157.947 60.3591 158.674 62.6897 158.674C64.9848 158.674 66.9063 157.955 68.4542 156.517V151.176H60.3146C60.19 151.176 60.1278 151.117 60.1278 151C60.1278 150.883 60.19 150.824 60.3146 150.824H68.641C68.7655 150.824 68.8278 150.883 68.8278 151V156.592C68.8278 156.643 68.81 156.684 68.7744 156.718C67.1554 158.239 65.1272 159 62.6897 159C60.2701 159 58.2419 158.239 56.605 156.718C54.986 155.18 54.1765 153.274 54.1765 151C54.1765 148.726 54.986 146.829 56.605 145.307C58.2419 143.769 60.2701 143 62.6897 143Z",
    stroke: "#272A32",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6446 143C94.0643 143 96.1192 143.786 97.8094 145.357C99.5174 146.912 100.371 148.793 100.371 151C100.371 153.207 99.5174 155.096 97.8094 156.668C96.1192 158.223 94.0643 159 91.6446 159C90.0612 159 88.6289 158.641 87.348 157.922C86.0848 157.203 85.0973 156.233 84.3857 155.013C83.6918 153.792 83.3449 152.455 83.3449 151C83.3449 149.545 83.6918 148.208 84.3857 146.987C85.0973 145.767 86.0848 144.797 87.348 144.078C88.6289 143.359 90.0612 143 91.6446 143ZM91.6446 143.326C89.3495 143.326 87.4458 144.07 85.9335 145.558C84.439 147.029 83.6918 148.843 83.6918 151C83.6918 153.157 84.439 154.979 85.9335 156.467C87.4458 157.938 89.3495 158.674 91.6446 158.674C93.9753 158.674 95.9502 157.93 97.5692 156.442C99.206 154.937 100.024 153.123 100.024 151C100.024 148.877 99.206 147.071 97.5692 145.583C95.9502 144.078 93.9753 143.326 91.6446 143.326Z",
    stroke: "#272A32",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.072 143H117.447C120.863 143 123.389 143.761 125.026 145.282C126.449 146.62 127.161 148.526 127.161 151C127.161 153.474 126.449 155.38 125.026 156.718C123.389 158.239 120.863 159 117.447 159H115.072C114.947 159 114.885 158.941 114.885 158.824C114.885 158.724 114.947 158.674 115.072 158.674H117.447C120.774 158.674 123.211 157.938 124.759 156.467C126.111 155.196 126.787 153.374 126.787 151C126.787 148.626 126.111 146.804 124.759 145.533C123.211 144.062 120.774 143.326 117.447 143.326H115.072C114.947 143.326 114.885 143.276 114.885 143.176C114.885 143.059 114.947 143 115.072 143Z",
    stroke: "#272A32",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.056 143C148.145 143 148.207 143.033 148.242 143.1L155.368 158.774C155.386 158.791 155.395 158.808 155.395 158.824C155.395 158.941 155.332 159 155.208 159C155.137 159 155.083 158.967 155.048 158.9L148.056 143.602L141.09 158.9C141.055 158.967 141.001 159 140.93 159C140.806 159 140.743 158.941 140.743 158.824C140.743 158.808 140.752 158.791 140.77 158.774L147.896 143.1C147.931 143.033 147.985 143 148.056 143Z",
    stroke: "#272A32",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.273 143C179.693 143 181.748 143.786 183.438 145.357C185.146 146.912 186 148.793 186 151C186 153.207 185.146 155.096 183.438 156.668C181.748 158.223 179.693 159 177.273 159C175.69 159 174.258 158.641 172.977 157.922C171.713 157.203 170.726 156.233 170.014 155.013C169.32 153.792 168.974 152.455 168.974 151C168.974 149.545 169.32 148.208 170.014 146.987C170.726 145.767 171.713 144.797 172.977 144.078C174.258 143.359 175.69 143 177.273 143ZM177.273 143.326C174.978 143.326 173.074 144.07 171.562 145.558C170.068 147.029 169.32 148.843 169.32 151C169.32 153.157 170.068 154.979 171.562 156.467C173.074 157.938 174.978 158.674 177.273 158.674C179.604 158.674 181.579 157.93 183.198 156.442C184.835 154.937 185.653 153.123 185.653 151C185.653 148.877 184.835 147.071 183.198 145.583C181.579 144.078 179.604 143.326 177.273 143.326Z",
    stroke: "#272A32",
    strokeWidth: 0.3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.6701 4.13724C93.7061 3.70957 94.3319 3.70956 94.368 4.13723L99.9493 70.3122C100.027 71.2367 100.268 72.1401 100.66 72.9809L119.832 114.079C120.014 114.469 119.47 114.78 119.227 114.426L96.904 81.9795C95.5125 79.9569 92.5256 79.9569 91.134 81.9795L68.8115 114.426C68.568 114.78 68.024 114.469 68.2057 114.079L87.3779 72.9809C87.7701 72.1401 88.0108 71.2367 88.0888 70.3122L93.6701 4.13724Z",
    fill: "url(#paint0_linear_10_460)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1647 70.5882L89.2455 55.7457C89.2593 55.5564 89.5223 55.5212 89.5853 55.7003L100.302 86.1464C100.369 86.335 100.118 86.4696 99.9976 86.3102L88.1997 70.7065C88.174 70.6726 88.1616 70.6306 88.1647 70.5882Z",
    fill: "#282A32"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55.6013,
    y: 100.776,
    width: 3.32426,
    height: 1.14258,
    transform: "rotate(135 55.6013 100.776)",
    fill: "url(#paint1_linear_10_460)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.32426,
    height: 1.14258,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 133.644 100.776)",
    fill: "url(#paint2_linear_10_460)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.93074,
    height: 1.14277,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 49.281 107.095)",
    fill: "url(#paint3_linear_10_460)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 0.479395,
    height: 1.14315,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 47.8083 108.568)",
    fill: "url(#paint4_linear_10_460)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 139.961,
    y: 107.095,
    width: 1.93074,
    height: 1.14277,
    transform: "rotate(-135 139.961 107.095)",
    fill: "url(#paint5_linear_10_460)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 141.148,
    y: 108.276,
    width: 0.282565,
    height: 1.14315,
    transform: "rotate(-135 141.148 108.276)",
    fill: "url(#paint6_linear_10_460)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.139 97.8249L111.375 78.061C108.573 75.2589 106.751 71.6263 106.182 67.7047L98.531 15.0503",
    stroke: "url(#paint7_linear_10_460)",
    strokeWidth: 0.875453
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3955 97.8249L77.1594 78.061C79.9615 75.2589 81.7832 71.6263 82.353 67.7047L90.0037 15.0503",
    stroke: "url(#paint8_linear_10_460)",
    strokeWidth: 0.875453
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M78.965 49.6652L82.9783 27.0903",
    stroke: "url(#paint9_linear_10_460)",
    strokeWidth: 0.875453
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M112.582 67.223L109.572 49.1631",
    stroke: "url(#paint10_linear_10_460)",
    strokeWidth: 0.875453
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M106.56 36.6214L105.556 29.5981",
    stroke: "url(#paint11_linear_10_460)",
    strokeWidth: 0.875453
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M87.4921 7.02367L87.9939 4.01318",
    stroke: "url(#paint12_linear_10_460)",
    strokeWidth: 0.875453
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_460",
    x1: 135.953,
    y1: 163.525,
    x2: 50.1384,
    y2: 39.0813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC5C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10_460",
    x1: 57.2634,
    y1: 100.776,
    x2: 57.2634,
    y2: 101.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10_460",
    x1: 1.66213,
    y1: 0,
    x2: 1.66213,
    y2: 1.14258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10_460",
    x1: 0.965368,
    y1: 0,
    x2: 0.965368,
    y2: 1.14277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10_460",
    x1: 0.239697,
    y1: 0,
    x2: 0.239697,
    y2: 1.14315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10_460",
    x1: 140.926,
    y1: 107.095,
    x2: 140.926,
    y2: 108.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10_460",
    x1: 141.289,
    y1: 108.276,
    x2: 141.289,
    y2: 109.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10_460",
    x1: 119.852,
    y1: 15.0503,
    x2: 119.852,
    y2: 97.8249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10_460",
    x1: 76.4587,
    y1: 17.0569,
    x2: 68.6829,
    y2: 97.8249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10_460",
    x1: 71.44,
    y1: 17.057,
    x2: 63.6642,
    y2: 97.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10_460",
    x1: 120.107,
    y1: 34.6148,
    x2: 127.883,
    y2: 115.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10_460",
    x1: 116.091,
    y1: 13.5449,
    x2: 123.867,
    y2: 94.3128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10_460",
    x1: 78.9624,
    y1: -17.0602,
    x2: 71.1853,
    y2: 63.7212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d547c9b100fbb7078a42827456eb53af.svg";
export { ForwardRef as ReactComponent };